import { render } from "./TopCreators.vue?vue&type=template&id=0fdf4bd2&ts=true"
import script from "./TopCreators.vue?vue&type=script&lang=ts"
export * from "./TopCreators.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__